<template>
    <v-container>
        <h1>Whoops!</h1>
        <p>You've come to a dead end here. Click <router-link to="/main">here</router-link> to go back home.</p>
    </v-container>
</template>

<script>
export default {
    name: "NotFound"
}
</script>
